export const htmlId: string = 'products-third-level';
export const allowedFileExtensions: string[] = ['rfa', 'pdf'];